import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{id}/availability-blocks/{availabilityBlockId}']['DELETE'];

const releaseAvailabilityBlockForCreator = async ({
  availabilityBlockId,
  creatorId,
}: ThisApi['params']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.delete(`/creators/${creatorId}/availability-blocks/${availabilityBlockId}`);
  return response.data;
};

export default releaseAvailabilityBlockForCreator;
